'use client';

import { Box, Typography } from '@mui/material';
import { useLocale } from 'next-intl';
import Image from 'next/image';

import { Link } from '@/i18n/navigation';
import colors from '@/styles/themes/colors';
import DateTime from '@/utils/static/DateTime';

import styles from './NavBlogCard.module.scss';

interface NavBlogCardProps {
  slug: string;
  title: string;
  cardImage: string;
  date: string;
  readTime: string;
}

const NavBlogCard = ({ slug, title, cardImage, date, readTime }: NavBlogCardProps) => {
  const locale = useLocale();
  const formattedDate = DateTime.formatBlogDate(date, locale);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const blogHref = `/blog/${slug}` as any;

  return (
    <Link href={blogHref} className={styles.container} role="menuitem">
      <Box className={styles.imageWrapper}>
        <Image src={cardImage} alt={title} fill sizes="(min-width: 1024px) 250px, 200px" className={styles.image} />
      </Box>
      <Box className={styles.content}>
        <Typography variant="body3" color={colors.graytone200}>
          {formattedDate} - {readTime}
        </Typography>
        <Typography variant="subtitle2" color={colors.white} className={styles.title} mt={1}>
          {title}
        </Typography>
      </Box>
    </Link>
  );
};

export default NavBlogCard;
